/*eslint-disable*/
import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  TextField,
  Typography,
  Divider,
  Paper,
  Grid,
  Box,
  FormControlLabel,
  Radio,
  RadioGroup
} from "@mui/material";
import { STYLES } from "config";
const ParkingDetailsComponent = forwardRef((props, ref) => {
  const { data, setvalue } = props;
  const [state, setstate] = useState(data);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    setstate(data);
  }, [data]);

  const updateData = (e) => {
    const updatedState = { ...state, [e.target.name]: e.target.value };
    setstate(updatedState);
    setvalue(updatedState);

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const updateDataNested = (e) => {
    const { name, value } = e.target;
    const keys = name.split(".");
    const updatedState = { ...state };

    let current = updatedState;
    for (let i = 0; i < keys.length - 1; i++) {
      current = current[keys[i]] = current[keys[i]] || {};
    }
    current[keys[keys.length - 1]] = value;

    setstate(updatedState);
    setvalue(updatedState);
  };


  //   useImperativeHandle(ref, () => ({
  //   isValidated() {
  //     const openingParkingBays = state?.openingParkingBays;

  //     const newErrors = {};

  //     if (!openingParkingBays || openingParkingBays === "") {
  //       newErrors.openingParkingBays = "Open Parking Bays is required";
  //     } else if (isNaN(openingParkingBays) || openingParkingBays < 0) {
  //       newErrors.openingParkingBays = "Must be a valid non-negative number";
  //     }

  //     setErrors(newErrors);
  //     return Object.keys(newErrors).length === 0;
  //   }
  // }));
  return (
    <Paper elevation={5} sx={{ p: 3 }}>
      <Box sx={{ p: 2 }}>
        {/* Parking Section */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 400,
            mb: 1,
            color: STYLES.WEB_APP_FONT_CLR
          }}
        >
          Parking
        </Typography>

        <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
          <Typography variant="body1">
            Parking information of the property important for Property 24
          </Typography>
        </Paper>

        <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Open Parking Bays:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="openingParkingBays"
              size="small"
              type="number"
              value={state?.openingParkingBays || ""}
              onChange={updateData}
              error={!!errors.openingParkingBays}
              helperText={errors.openingParkingBays}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: errors.openingParkingBays ? "red" : "#003366"
                  },
                  "&:hover fieldset": {
                    borderColor: errors.openingParkingBays ? "red" : "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
              inputProps={{ min: 0 }}
            />
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Covered Parking Bays:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="coveredParkingBays"
              size="small"
              value={data?.coveredParkingBays || ""}
              onChange={updateData}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>
        </Grid>

        {/* Power Information Section */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 400,
            mb: 1,
            mt: 4,
            color: STYLES.WEB_APP_FONT_CLR
          }}
        >
          Power Information
        </Typography>

        <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Paper elevation={0} sx={{ p: 2, mb: 2 }}>
          <Typography variant="body1">
            Power Details are the power information of the property.
          </Typography>
        </Paper>

        <Divider sx={{ borderColor: STYLES.WEB_APP_FONT_CLR, mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Power 3 Phase:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <RadioGroup
              row
              name="threePhasePower"
              value={data?.threePhasePower === true
                ? "YES"
                : data?.threePhasePower === false
                  ? "NO"
                  : ""}
              onChange={updateData}
            >
              <FormControlLabel
                value="YES"
                control={
                  <Radio
                    sx={{
                      color: STYLES.PRIMARY_APP_CLR,
                      "&.Mui-checked": {
                        color: STYLES.PRIMARY_APP_CLR
                      }
                    }}
                  />
                }
                label="YES"
                sx={{ color: STYLES.WEB_APP_FONT_CLR }}
              />
              <FormControlLabel
                value="NO"
                control={
                  <Radio
                    sx={{
                      color: STYLES.PRIMARY_APP_CLR,
                      "&.Mui-checked": {
                        color: STYLES.PRIMARY_APP_CLR
                      }
                    }}
                  />
                }
                label="NO"
                sx={{ color: STYLES.WEB_APP_FONT_CLR }}
              />
            </RadioGroup>
          </Grid>

          <Grid item size={2}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 400,
                mt: 1.5,
                color: STYLES.WEB_APP_FONT_CLR
              }}
            >
              Power Amps:
            </Typography>
          </Grid>
          <Grid item size={10}>
            <TextField
              fullWidth
              name="powerAmps"
              size="small"
              value={data?.powerAmps || ""}
              onChange={updateData}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#003366"
                  }
                },
                "& .MuiInputBase-input": {
                  color: STYLES.WEB_APP_FONT_CLR
                }
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
});

export default ParkingDetailsComponent;
